export default ["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  // Now set up the states
  $stateProvider
    .state('transactionList', {
      parent: "app",
      url: "/transactions?chargetypeCode&filterName&contractIdentifier&description&tranDateFrom&tranDateUntil&amount.valueFrom&amount.valueUntil&fakDateFrom&fakDateUntil&originalAmount.valueFrom&originalAmount.valueUntil&settled&fakDateDynamicFilter&tranDateDynamicFilter&dateFormat&downloadError&type.base",
      feature: "menu.transactions",
      views: {
        "main": {
          template: "<ea-transaction-page/>"
        }
      },
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          return $q((resolve)=> {
            require.ensure([], ()=> {
              let module = require("./index.js");
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }]
      }
    })
    .state("transactionDetails", {
      parent: "app",
      url: "/transactions/:id",
      feature: "menu.transactions",
      views: {
        "main": {
          template: "<ea-transaction-detail-page/>"
        }
      },
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          return $q((resolve)=> {
            require.ensure([], ()=> {
              let module = require("./index.js");
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }],
        detailPageFeature: ["FeatureService", (FeatureService) => {
          return FeatureService.hasFeature("transactions.detailPage");
        }]
      }
    });
}];



// WEBPACK FOOTER //
// ./src/ui/modules/eaTransaction/routes.js